import React from 'react'
import styled from 'styled-components'

const Styling = styled.div`
    .swipe-slider{
    background:var(--white);
    padding:1rem;
    margin-bottom: 4rem;

        .swiper-slide {
        height: auto;

            .gatsby-image-wrapper{
            height:100%;
            width: 100%;
            }
        }

        .swiper-pagination{
        padding-right:2rem;
        text-align:right;
        bottom:2rem;
        }

        .swiper-button-prev{
        left:2rem;
        }
        .swiper-button-next{
        right:2rem;
        }

        .swiper-pagination-bullet{
        background:var(--white);
        opacity:1;
        border:1px solid var(--white);

            &-active{
            background:var(--blue_dark);
            }

        }

        .swiper-button-next, 
        .swiper-button-prev{
            color:var(--blue_dark);
            text-shadow:3px 0px 0px var(--white);
        }
    }
`

export { Styling }